export default "__VITE_ASSET__Vn0x6hYnhSZIl_YmIM6XzA__"